import React from "react";
import {
  AppstoreOutlined,
  ClockCircleOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  TeamOutlined,
  DesktopOutlined,
  NotificationOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
  IdcardOutlined,
  TagsOutlined,
  DollarOutlined,
} from "@ant-design/icons";

import { PERMISSIONS } from "./permissions";
import * as ROUTES from "./routes";

import ApprovedCabinet from "../components/Dashboard/approvedCabinet";
import UnapprovedCabinet from "../components/Dashboard/unapprovedCabinet";
import Orders from "../components/Dashboard/orders";
import InvoiceReport from "../components/Dashboard/invoiceReport";
import Customer from "../components/Dashboard/customer";
import Kiosk from "../components/Dashboard/kiosk";
import Advertisement from "../components/Dashboard/advertisement";
import Users from "../components/Dashboard/users";
import Permissions from "../components/Dashboard/permissions";
import Roles from "../components/Dashboard/roles";
import CouponCodes from "../components/Dashboard/couponCodes";
import Pricing from "../components/Dashboard/pricing";

/**
 * Sidebar groups (display only)
 */
export const SECTION_GROUPS = [
  { key: "operations", label: "Operations" },
  { key: "billing", label: "Customers & Billing" },
  { key: "marketing", label: "Marketing" },
  { key: "access", label: "Access Control" },
];

/**
 * Dashboard sections. Each one is a route of its own: `path` is what the
 * sidebar navigates to and what the router renders.
 */
export const DASHBOARD_SECTIONS = [
  {
    key: "1",
    path: ROUTES.APPROVED_CABINETS,
    label: "Approved Cabinets",
    group: "operations",
    icon: <AppstoreOutlined />,
    permissions: [PERMISSIONS.READ_CABINET],
    children: <ApprovedCabinet />,
  },
  {
    key: "2",
    path: ROUTES.UNAPPROVED_CABINETS,
    label: "Unapproved Cabinets",
    group: "operations",
    icon: <ClockCircleOutlined />,
    permissions: [PERMISSIONS.CREATE_CABINET],
    children: <UnapprovedCabinet />,
  },
  {
    key: "3",
    path: ROUTES.ORDERS,
    label: "Orders",
    group: "billing",
    icon: <ShoppingCartOutlined />,
    permissions: [PERMISSIONS.READ_ORDERS, PERMISSIONS.READ_CABINET],
    children: <Orders />,
  },
  {
    key: "4",
    path: ROUTES.INVOICE_REPORTS,
    label: "Invoice Reports",
    group: "billing",
    icon: <FileTextOutlined />,
    permissions: [PERMISSIONS.VIEW_REPORTS, PERMISSIONS.READ_CABINET],
    children: <InvoiceReport />,
  },
  {
    key: "5",
    path: ROUTES.CUSTOMERS,
    label: "Customers",
    group: "billing",
    icon: <TeamOutlined />,
    permissions: [PERMISSIONS.READ_CUSTOMERS],
    children: <Customer />,
  },
  {
    key: "6",
    path: ROUTES.KIOSKS,
    label: "Kiosks",
    group: "operations",
    icon: <DesktopOutlined />,
    permissions: [PERMISSIONS.LIST_KIOSKS],
    children: <Kiosk />,
  },
  {
    key: "7",
    path: ROUTES.ADVERTISEMENTS,
    label: "Advertisements",
    group: "marketing",
    icon: <NotificationOutlined />,
    permissions: [PERMISSIONS.READ_ADVERTISEMENTS],
    children: <Advertisement />,
  },
  {
    key: "8",
    path: ROUTES.USERS,
    label: "Users",
    group: "access",
    icon: <UserOutlined />,
    permissions: [PERMISSIONS.READ_USERS],
    children: <Users />,
  },
  {
    key: "9",
    path: ROUTES.PERMISSIONS,
    label: "Permissions",
    group: "access",
    icon: <SafetyCertificateOutlined />,
    permissions: [PERMISSIONS.UPDATE_USERS, PERMISSIONS.READ_USERS],
    children: <Permissions />,
  },
  {
    key: "10",
    path: ROUTES.ROLES,
    label: "Roles",
    group: "access",
    icon: <IdcardOutlined />,
    permissions: [PERMISSIONS.UPDATE_USERS, PERMISSIONS.READ_USERS],
    children: <Roles />,
  },
  {
    key: "11",
    path: ROUTES.COUPON_CODES,
    label: "Coupon Codes",
    group: "billing",
    icon: <TagsOutlined />,
    permissions: [PERMISSIONS.ONLY_FOR_SUPERADMIN],
    children: <CouponCodes />,
  },
  {
    key: "12",
    path: ROUTES.PRICING,
    label: "Pricings",
    group: "billing",
    icon: <DollarOutlined />,
    permissions: [PERMISSIONS.READ_PRICINGS],
    children: <Pricing />,
  },
];
